import React, { useState, useEffect } from 'react'
import { useTranslate, useRecordContext, useNotify, useRefresh } from 'react-admin'
import { ShowElement } from 'src/components/uiElements/CRUD/ShowElement'
import EventIcon from '@mui/icons-material/Event'
import TrainIcon from '@mui/icons-material/Train'
import { cloneItemReservation } from 'src/components/pages/sales/reservation/helper/cloneItemReservation'
import { afterSalesItemReservation } from 'src/components/pages/sales/reservation/helper/afterSalesItemReservation'
import { BillingStatusField } from 'src/components/pages/sales/reservation/logic/common/BillingStatusField'
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Typography,
  TableContainer,
  Table,
  TableBody,
  Button,
  TextField,
  Backdrop,
  CircularProgress,
  Tooltip,
  Checkbox,
} from '@mui/material'
import AttachMoneyIcon from '@mui/icons-material/AttachMoney'
import EditIcon from '@mui/icons-material/Edit'
import PhoneIcon from '@mui/icons-material/Phone'
import { turquoise, blue } from 'src/assets/colors'
import LocationOnIcon from '@mui/icons-material/LocationOn'
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth'
import {
  ShowCard,
  RigthSideCard,
  LeftSideCard,
  CompleteSideCard,
} from 'src/components/uiElements/cards/ShowCard'
import { Passenger } from 'src/components/pages/sales/reservation/logic/common/Passenger'
import { TabProduct } from 'src/components/pages/sales/reservation/logic/common/TabProduct'
import { ToolbarReservation } from 'src/components/pages/sales/reservation/logic/common/ToolbarReservation'
import { handleUpdateContact } from 'src/components/pages/sales/reservation/helper/handleUpdateContact'
import { handleUpdatePricing } from 'src/components/pages/sales/reservation/helper/handleUpdatePricing'
import { ContactModal } from 'src/components/pages/sales/reservation/logic/modals/ContactModal'
import { PricingModal } from 'src/components/pages/sales/reservation/logic/modals/PricingModal'
import { LiquidationPricing } from 'src/components/pages/sales/reservation/logic/common/LiquidationPricing'
import { useCardLoading } from 'src/components/pages/sales/reservation/context/CardLoadingContext'
import { WrapperCardId } from 'src/components/pages/sales/reservation/logic/common/WrapperCardId'
import { deleteItemReservation } from 'src/components/pages/sales/reservation/helper/deleteItemReservation'
import { ConfirmationDialog } from 'src/components/uiElements/styledComponents/ConfirmationDialog'
import { cancelTrainPassesReservation } from 'src/components/pages/sales/reservation/helper/cancelTrainPassesReservation'
import { TrainPassesExtraPassenger } from 'src/components/pages/sales/reservation/logic/train/TrainPassesExtraPassenger'
import { TrainPassesCondition } from 'src/components/pages/sales/reservation/logic/train/TrainPassesCondition'
import { DateInDateOutField } from 'src/components/pages/sales/reservation/logic/common/DateInDateOut'
import { emitItemReservation } from 'src/components/pages/sales/reservation/helper/emitItemReservation'
import { retriveItemReservation } from 'src/components/pages/sales/reservation/helper/retriveItemReservation'
import { INVOICED } from 'src/components/pages/sales/reservation/logic/common/state'
import { getDay } from 'src/components/pages/sales/reservation/helper/getDay'
import { TrainPassesForm } from 'src/components/pages/sales/reservation/logic/train/TrainPassesForm'
import { HasPermission, hasPermissionFunction } from 'src/helper/HasPermission'
import { EditOriginValues } from '../common/EditOriginValues'
import { Comment } from '@mui/icons-material'
import { EditInputsWrap } from 'src/components/uiElements/CRUD/EditInputsWrap'
import { itemServices } from 'src/services/reservation/item/item.service'
import { customAwait } from '../../helper/customAwait'
import {
  PERMISSION_GET,
  PERMISSION_IS_BILLABLE,
  PERMISSION_SHOW,
  VIEW_LIQUIDATION_RETAIL,
  VIEW_LIQUIDATION_SUPPLIER,
  VIEW_LIQUIDATION_WHOLESALER,
} from 'src/helper/Permission'
import { NotificationEmails } from 'src/components/pages/sales/reservation/logic/common/NotificationEmails'
import { FilesCard as FilesCardComponent } from '../common/FilesCard'
import { TrainPassesTicket } from 'src/components/pages/sales/reservation/logic/train/TrainPassesTicket'
import { BillingAutomaticField } from '../common/BillingAutomaticField'
import { hasLiquidation, hasNotErrorInliquidation } from 'src/components/pages/sales/reservation/logic/common/hasLiquidation'
import { ExchangeType } from '../common/ExchangeType'
import { DueDateOfProduct } from '../common/DueDateOfProduct'
import { DUE_DATE_RANGE_PERMISSION_ENTITY } from 'src/helper/resourcesByPermission'
import { approveRefuseFraudItemReservation } from '../../helper/approveRefuseFraudItemReservation'
import {CommentsCardComponent} from '../common/CommentsCardComponent'
import { PostVentaStatus } from '../common/postventaStatus'
import { registerReturn } from '../../helper/registerReturn'
import { HistoryCostsDialog } from '../common/HistoryCostsDialog'
import CloseIcon from '@mui/icons-material/Close';
import { ChangeStatusDialog } from '../common/ChangeStatusDialog'
import { pricingServices } from 'src/services/reservation/pricing/pricing.service'
import { reservationServices } from 'src/services/sales/reservation/reservation.service'

const ContextTrainPasses = () => {
  const train_passes = useRecordContext()
  if (train_passes) {
    return (
      <>
        <HasPermission permission={PERMISSION_SHOW} resource={DUE_DATE_RANGE_PERMISSION_ENTITY}>
          <DueDateOfProduct />
        </HasPermission>
        <Passenger itemId={train_passes.item_id} passengers={train_passes?.pax_relation} />
      </>
    )
  }
}

const PassengerTrainPasses = ({ reservation }) => {
  const train = useRecordContext()
  const translate = useTranslate()

  const getTitularPassenger = () => {
    if (reservation?.passenger) {
      return reservation?.passenger
    } else {
      const passenger = train?.pax_relation?.find((elem) => elem.is_titular)
      return passenger ? `${passenger.name} ${passenger.surname}` : ''
    }
  }

  return <ShowElement data={getTitularPassenger()} label={translate('ra.field.passenger')} />
}

const ContextTrainPassesForm = ({ reservation, openProductModal, onSubmitProduct, setOpenProductModal }) => {
  const train_passes = useRecordContext()
  if (train_passes && openProductModal) {
    return (
      <TrainPassesForm
        openModal={openProductModal}
        reservation={reservation}
        passengers={reservation?.passengers}
        workUnit={reservation.work_unit_relation}
        product={train_passes}
        handleClose={() => setOpenProductModal(false)}
        onSubmit={(data, cardId) => onSubmitProduct(data, cardId)}
        recordProduct={train_passes}
      />
    )
  }
}

const ObservationsCard = () => {
  const translate = useTranslate()
  const item = useRecordContext()
  if (item && item.observations) {
    return (
      <ShowCard iconHeader={<Comment />} title={translate('ra.title.observations')} variant='text'>
        <CompleteSideCard>
          <ShowElement source='observations' onlyValue />
        </CompleteSideCard>
      </ShowCard>
    )
  }
}

const LiquidationCards = ({enableReliquidation}) => {
  const translate = useTranslate()
  const item = useRecordContext()
  const notify = useNotify()
  const refresh = useRefresh()
  const [refreshLiquidation, setRefreshLiquidation] = useState(0)
  const [openReliquidateModal, setOpenReliquidateModal] = useState(false)
  const [confirmReliquidate, setConfirmReliquidate] = useState(false)
  const [reliquidateType, setReliquidateType] = useState(0)
  const [reliquidateLoading, setReliquidateLoading] = useState(false)
  
  const onReliquidate = async () =>{
    setReliquidateLoading(true)
    if(reliquidateType === 0){
      await pricingServices.reliquidate_wholesaler([item.hash_]).then(()=>{
        setOpenReliquidateModal(false)
        setConfirmReliquidate(false)
        refresh()
        setTimeout(() => {
          setRefreshLiquidation(refreshLiquidation+1)
        }, 2000);
      }).catch(()=>{
        notify('ra.message.reliquidation_error', {type:'error'})
      }).finally(()=>{
        setReliquidateLoading(false)
      })
    }
    else if(reliquidateType === 1){
      await pricingServices.reliquidate_retail([item.hash_]).then(()=>{
        setOpenReliquidateModal(false)
        setConfirmReliquidate(false)
        refresh()
        setTimeout(() => {
          setRefreshLiquidation(refreshLiquidation+1)
        }, 2000);
      }).catch(()=>{
        notify('ra.message.reliquidation_error', {type:'error'})
      }).finally(()=>{
        setReliquidateLoading(false)
      })
    }
    else if(reliquidateType === 2){
      await pricingServices.reliquidate_supplier([item.hash_]).then(()=>{
        setOpenReliquidateModal(false)
        setConfirmReliquidate(false)
        refresh()
        setTimeout(() => {
          setRefreshLiquidation(refreshLiquidation+1)
        }, 2000);
      }).catch(()=>{
        notify('ra.message.reliquidation_error', {type:'error'})
      }).finally(()=>{
        setReliquidateLoading(false)
      })
    }
    
  }

  useEffect(()=>{
    if(confirmReliquidate){
      onReliquidate()
    }
  },[confirmReliquidate])

  const decideLiquidation = () =>{
    if(reliquidateType === 0){
      return translate('ra.title.liquidation_wholesaler')
    }
    if(reliquidateType === 1){
      return translate('ra.title.liquidation_retail')
    }
    if(reliquidateType === 2){
      return translate('ra.title.liquidation_supplier')
    }
  }

  return (
    <>
      <ExchangeType />
      {hasLiquidation(item?.pricing_relation?.[0]?.liquidation_wholesaler) && (
        <HasPermission permission={VIEW_LIQUIDATION_WHOLESALER} resource={'pricing'}>
          <ShowCard
            iconHeader={
              <Tooltip title={hasPermissionFunction('pricing', 'edit_liquidation_wholesaler') && enableReliquidation && translate('ra.action.reliquidate')}>
                <AttachMoneyIcon 
                  color={hasPermissionFunction('pricing', 'edit_liquidation_wholesaler') && enableReliquidation ? 'primary' : 'inherit'}
                  style={{cursor:hasPermissionFunction('pricing', 'edit_liquidation_wholesaler') && enableReliquidation ? 'pointer' : 'default'}}
                  onClick={async ()=>{
                    if(hasPermissionFunction('pricing', 'edit_liquidation_wholesaler') && enableReliquidation){
                      setOpenReliquidateModal(true)
                      setReliquidateType(0)
                    }
                  }}
                />
              </Tooltip>
            }
            title={translate('ra.title.liquidation_wholesaler')}
            variant='text'
            optionHeigth={'liquidation'}
          >
            <TableContainer>
              <Table>
                <TableBody key={`wholesaler${refreshLiquidation}`}>
                  <LiquidationPricing node_liquidation='liquidation_wholesaler' />
                </TableBody>
              </Table>
            </TableContainer>
          </ShowCard>
        </HasPermission>
      )}

      {hasLiquidation(item?.pricing_relation?.[0]?.liquidation_retail) &&
        hasNotErrorInliquidation(item?.pricing_relation?.[0]?.liquidation_retail) && (
          <HasPermission permission={VIEW_LIQUIDATION_RETAIL} resource={'pricing'}>
            <ShowCard
              iconHeader={<Tooltip title={hasPermissionFunction('pricing', 'edit_liquidation_retail') && enableReliquidation && translate('ra.action.reliquidate')}>
                <AttachMoneyIcon 
                  color={hasPermissionFunction('pricing', 'edit_liquidation_wholesaler') && enableReliquidation ? 'primary' : 'inherit'}
                  style={{cursor:hasPermissionFunction('pricing', 'edit_liquidation_retail') && enableReliquidation ? 'pointer' : 'default'}}
                  onClick={async ()=>{
                    if(hasPermissionFunction('pricing', 'edit_liquidation_retail') && enableReliquidation){
                      setOpenReliquidateModal(true)
                      setReliquidateType(1)
                    }
                  }}
                />
              </Tooltip>}
              title={translate('ra.title.liquidation_retail')}
              variant='text'
              optionHeigth={'liquidation'}
            >
              <TableContainer>
                <Table>
                  <TableBody key={`retail${refreshLiquidation}`}>
                    <LiquidationPricing node_liquidation='liquidation_retail' />
                  </TableBody>
                </Table>
              </TableContainer>
            </ShowCard>
          </HasPermission>
        )}

      {hasLiquidation(item?.pricing_relation?.[0]?.liquidation_supplier) && (
        <HasPermission permission={VIEW_LIQUIDATION_SUPPLIER} resource={'pricing'}>
          <ShowCard
            iconHeader={<Tooltip title={hasPermissionFunction('pricing', 'edit_liquidation_supplier') && enableReliquidation && translate('ra.action.reliquidate')}>
                <AttachMoneyIcon 
                  color={hasPermissionFunction('pricing', 'edit_liquidation_wholesaler') && enableReliquidation ? 'primary' : 'inherit'}
                  style={{cursor:hasPermissionFunction('pricing', 'edit_liquidation_supplier') && enableReliquidation ? 'pointer' : 'default'}}
                  onClick={async ()=>{
                    if(hasPermissionFunction('pricing', 'edit_liquidation_supplier') && enableReliquidation){
                      setOpenReliquidateModal(true)
                      setReliquidateType(2)
                    }
                  }}
                />
              </Tooltip>}
            title={translate('ra.title.liquidation_supplier')}
            variant='text'
            optionHeigth={'liquidation'}
          >
            <TableContainer>
              <Table>
                <TableBody key={`supplier${refreshLiquidation}`}>
                  <LiquidationPricing node_liquidation='liquidation_supplier' />
                </TableBody>
              </Table>
            </TableContainer>
          </ShowCard>
        </HasPermission>
      )}
      <ConfirmationDialog
        title={decideLiquidation()}
        contentText={translate('ra.message.reliquidation_confirm', {liquidation:decideLiquidation()})}
        buttonConfirmText={translate('ra.message.yes')}
        buttonCancel={translate('ra.message.no')}
        setOpen={setOpenReliquidateModal}
        setConfirm={setConfirmReliquidate}
        open={openReliquidateModal}
        loadingModalButton={reliquidateLoading}
      />
    </>
  )
}

const FilesCard = () => {
  const translate = useTranslate()
  const train_passes = useRecordContext()
  if (train_passes) {
    return (
      <ShowCard title={translate('ra.title.files')}>
        <FilesCardComponent recordProduct={train_passes} />
      </ShowCard>
    )
  }
}

export const TrainPassesProduct = ({ reservation, train_passes, editMode = false }) => {
  const translate = useTranslate()
  const notify = useNotify()
  const refresh = useRefresh()

  const [confirmEmit, setConfirmEmit] = useState(false)
  const [openEmitModal, setOpenEmitModal] = useState(false)
  const [loadingEmitItem, setLoadingEmitItem] = useState(false)

  const [openRetriveModal, setOpenRetriveModal] = useState(false)
  const [loadingRetriveItem, setLoadingRetriveItem] = useState(false)
  const [confirmRetrive, setConfirmRetrive] = useState(false)

  const [open, setOpen] = useState(false)
  const [openModalCondition, setOpenModalCondition] = useState(false)
  const [confirm, setConfirm] = useState(false)

  const [openDeleteModal, setOpenDeleteModal] = useState(false)
  const [confirmDelete, setConfirmDelete] = useState(false)
  const [loadingDeleteItem, setLoadingDeleteItem] = useState(false)

  const [openMoveModal, setOpenMoveModal] = useState(false)
  const [loadingMoveItem, setLoadingMoveItem] = useState(false)
  const [reservationNumberMove, setReservationNumberMove] = useState('')

  const [nameReserve, setNameReserve] = useState('')
  const [hashItemReserve, setHashItemReserve] = useState('')

  const [loadingCancelItem, setLoadingCancelItem] = useState(false)
  // const [individualRecord, setIndividualRecord] = useState({})
  // const [openLiqudiationPricingModal, setOpenLiqudiationPricingModal] = useState(false)
  // const [loadingLiqudiationPricingModal, setLoadingLiqudiationPricingModal] = useState(false)
  // const [exchangeMode, setExchangeMode] = useState(false)

  const [openContactModal, setOpenContactModal] = useState(false)
  const [loadingContactModal, setLoadingContactModal] = useState(false)
  const [openPricingModal, setOpenPricingModal] = useState(false)
  const [loadingPricingModal, setLoadingPricingModal] = useState(false)

  const [costCancel, setCost] = useState(0)
  const [currencyCostCancel, setCurrencyCost] = useState('')
  const [costCancelLoading, setCostLoading] = useState(false)

  const { setCardLoading } = useCardLoading()

  const [wasEmitted, setWasEmitted] = useState({})
  const [openProductModal, setOpenProductModal] = useState(false)

  const [openFraudModal, setOpenFraudModal] = useState(false)
  const [confirmFraud, setConfirmFraud] = useState(false)
  const [approveFraud, setApproveFraud] = useState(false)
  const [loadingFraudItem, setLoadingFraudItem] = useState(false)

  const [openCloneModal, setOpenCloneModal] = useState(false)
  const [confirmClone, setConfirmClone] = useState(false)
  const [loadingCloneItem, setLoadingCloneItem] = useState(false)

  const [openAfterSalesModal, setOpenAfterSalesModal] = useState(false)
  const [confirmAfterSales, setConfirmAfterSales] = useState(false)
  const [loadingAfterSalesItem, setLoadingAfterSalesItem] = useState(false)

  const [openRegisterReturnModal, setOpenRegisterReturnModal] = useState(false)
  const [confirmRegisterReturn, setConfirmRegisterReturn] = useState(false)
  const [loadingRegisterReturnItem, setLoadingRegisterReturnItem] = useState(false)

  const [historyCostsDialog, setHistoryCostsDialog] = useState()

  const [changePostVentaStatus, setChangePostventaStatus] = useState(false)
  const [loadingPostventaStatus, setLoadingPostventaStatus] = useState(false)
  const [actualStatus, setActualStatus] = useState('')

  const [changeStatusDialog, setChangeStatusDialog] = useState(false)

  const [isBillable, setIsBillable] = useState(train_passes[0].is_billable)

  const [enableReliquidation, setEnableReliquidation] = useState(false)

  useEffect(()=>{
    const items = reservation.items
    const foundItem = items.find(item=>item.id === train_passes[0].id)
    setIsBillable(foundItem.is_billable)
  },[reservation])

  useEffect(() => {
    if (confirmClone) {
      cloneItemReservation({
        hashItemReserve,
        nameReserve,
        refresh,
        notify,
        setLoadingCloneItem,
        setNameReserve,
        setHashItemReserve,
        setConfirmClone,
        setOpenCloneModal,
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [confirmClone])

  useEffect(() => {
      if (confirmRegisterReturn) {
        registerReturn({
          hashItemReserve,
          nameReserve,
          refresh,
          notify,
          setLoadingRegisterReturnItem,
          setNameReserve,
          setHashItemReserve,
          setConfirmRegisterReturn,
          setOpenRegisterReturnModal,
        })
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [confirmRegisterReturn])

  useEffect(() => {
      if (confirmAfterSales) {
        afterSalesItemReservation({
          hashItemReserve,
          nameReserve,
          refresh,
          notify,
          setLoadingAfterSalesItem,
          setNameReserve,
          setHashItemReserve,
          setConfirmAfterSales,
          setOpenAfterSalesModal,
        })
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [confirmAfterSales])

    useEffect(() => {
      if (changePostVentaStatus) {
        PostVentaStatus({
          hashItemReserve,
          nameReserve,
          refresh,
          notify,
          setLoadingPostventaStatus,
          setNameReserve,
          setHashItemReserve,
          setChangePostventaStatus,
          actualStatus
        })
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [changePostVentaStatus])

  useEffect(() => {
    let wasEmittedKeys = Object.keys(wasEmitted)
    if (train_passes && Array.isArray(train_passes) && train_passes.length > 0 && wasEmittedKeys.length > 0) {
      wasEmittedKeys.forEach((emit) => {
        const isEmmited = train_passes.find(
          (train_pass) => train_pass?.hash_ === emit && train_pass?.status === INVOICED
        )
        if (wasEmitted[emit] && isEmmited) {
          setWasEmitted((prev) => ({
            ...prev,
            [emit]: false,
          }))
          setLoadingEmitItem(false)
        }
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [train_passes, wasEmitted])

  useEffect(() => {
    if (confirmDelete) {
      deleteItemReservation({
        hashItemReserve,
        nameReserve,
        refresh,
        notify,
        setLoadingDeleteItem,
        setNameReserve,
        setHashItemReserve,
        setConfirmDelete,
        setOpenDeleteModal,
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [confirmDelete])

  useEffect(() => {
    if (confirmRetrive) {
      retriveItemReservation({
        hashItemReserve,
        nameReserve,
        refresh,
        notify,
        setHashItemReserve,
        setLoadingRetriveItem,
        setNameReserve,
        setConfirmRetrive,
        setOpenRetriveModal,
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [confirmRetrive])

  useEffect(() => {
    if (confirm) {
      cancelTrainPassesReservation({
        hashItemReserve,
        nameReserve,
        refresh,
        notify,
        setLoadingCancelItem,
        setNameReserve,
        setHashItemReserve,
        setConfirm,
        setOpen,
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [confirm])

  useEffect(() => {
    if (confirmEmit) {
      emitItemReservation({
        hashItemReserve,
        nameReserve,
        refresh,
        notify,
        setHashItemReserve,
        setLoadingEmitItem,
        setNameReserve,
        setConfirmEmit,
        setOpenEmitModal,
        setWasEmitted,
        translate,
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [confirmEmit])

  useEffect(() => {
    if (confirmFraud) {
      approveRefuseFraudItemReservation({
        hashItemReserve,
        approveFraud,
        refresh,
        notify,
        setHashItemReserve,
        setLoadingFraudItem,
        setConfirmFraud,
        setOpenFraudModal
      })
      
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [confirmFraud])

  const onSubmitProduct = (data, cardId) => {
    setCardLoading(cardId, true)
  }

  const handleMoveItem = async () => {
    if (reservationNumberMove) {
      setLoadingMoveItem(true)
      setOpenMoveModal(false)
      try {
        await itemServices.move_item(hashItemReserve, reservationNumberMove, reservation.number)
        notify('ra.notification.move_item_success', {
          type: 'success',
          messageArgs: { item: nameReserve },
        })
      } catch (error) {
        if(error.response.data?.detail){
          notify(error.response.data?.detail, {
            type: 'error',
          })
        } else {
          notify('ra.notification.move_item_error', {
            type: 'error',
            messageArgs: { item: nameReserve },
          })
        }
      } finally {
        customAwait([refresh])
        setNameReserve('')
        setHashItemReserve('')
        setReservationNumberMove('')
        setLoadingMoveItem(false)
      }
    }
  }

  const getCostToCancelTrainSegment = async (hash) => {
    try {
      setCostLoading(true)
      const constToCancel = await itemServices.cancel_item(hash)
      if (constToCancel?.refund_value !== null && constToCancel?.currency) {
        setCost(constToCancel.refund_value)
        setCurrencyCost(constToCancel.currency)
      }
    } catch (error) {
    } finally {
      setCostLoading(false)
    }
  }

  const onChangeBillable = async () =>{
    const newValue = !isBillable
    setIsBillable(newValue)
    await reservationServices.updateIsBillableProduct(train_passes[0].hash_, newValue).then(()=>{
      notify('ra.notification.updated_success_masculine', {
          type: 'success',
          messageArgs: { element: translate('ra.single_entity.product') },
        })
    }).catch(()=>{
      notify('ra.notification.updated_error_masculine', {
        type: 'error',
        messageArgs: { element: translate('ra.single_entity.product') },
      })
    })
  }

  if (train_passes) {
    return (
      <>
        <Backdrop
          sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={loadingRetriveItem || loadingDeleteItem || loadingCancelItem || loadingEmitItem}
        >
          <CircularProgress color='inherit' />
        </Backdrop>
        <TabProduct
          products={train_passes}
          labelGetter={(product) => (product?.id_detail ? product?.passes?.[0]?.company_name : 'ERROR')}
          getStyle={(product) => (product?.id_detail ? null : { color: 'red' })}
        >
          {!editMode && (
            <ToolbarReservation
              resource='train-detail'
              loadingCancel={loadingCancelItem}
              onCancel={(train_passes) => {
                setOpen(true)
                setHashItemReserve(train_passes?.hash_)
                setNameReserve(train_passes?.passes?.[0]?.company_name)
                getCostToCancelTrainSegment(train_passes?.hash_)
              }}
              onEmit={(train_passes) => {
                setOpenEmitModal(true)
                setHashItemReserve(train_passes?.hash_)
                setNameReserve(train_passes?.passes?.[0]?.company_name)
              }}
              onRetrive={(train_passes) => {
                setOpenRetriveModal(true)
                setHashItemReserve(train_passes?.hash_)
                setNameReserve(train_passes?.passes?.[0]?.company_name)
              }}
              onClone={(train_passes) => {
                setOpenCloneModal(true)
                setHashItemReserve(train_passes?.hash_)
                setNameReserve(train_passes?.passes?.[0]?.company_name)
              }}
              loadingEmitItem={loadingEmitItem}
              onDeleted={(train_passes) => {
                setOpenDeleteModal(true)
                setHashItemReserve(train_passes?.hash_)
                setNameReserve(train_passes?.passes?.[0]?.company_name)
              }}
              loadingDeleteItem={loadingDeleteItem}
              onMove={(train_passes) => {
                setOpenMoveModal(true)
                setHashItemReserve(train_passes?.hash_)
                setNameReserve(train_passes?.passes?.[0]?.company_name)
              }}
              loadingMoveItem={loadingMoveItem}
              labelCancelButton={'ra.action.issuance'}
              reservation={reservation}
              setOpenProductModal={setOpenProductModal}
              onAfterSales={(train_passes)=>{
                setOpenAfterSalesModal(true)
                setHashItemReserve(train_passes?.hash_)
                setNameReserve(train_passes?.passes?.[0]?.company_name)}
              }
              setLoadingMoveItem={setLoadingMoveItem}
              loadingAfterSales={loadingAfterSalesItem}
              setLoadingAfterSalesItem={setLoadingAfterSalesItem}
              onRegisterReturn={
                (train_passes)=>{
                  setOpenRegisterReturnModal(true)
                  setHashItemReserve(train_passes?.hash_)
                  setNameReserve(train_passes?.passes?.[0]?.company_name)}
              }
              loadingRegisterReturn = {loadingRegisterReturnItem}
              setLoadingRegisterReturn = {setLoadingRegisterReturnItem}
              postventaStatusButton={(train_passes)=>{
                setChangePostventaStatus(true)
                setHashItemReserve(train_passes?.hash_)
                setActualStatus(train_passes.status)
              }}
              loadingPostventaStatus={loadingPostventaStatus}
            />
          )}

          <Box display={'flex'}>
            <div className='responsive-products-info'>
              <WrapperCardId>
                <ContextTrainPassesForm
                  reservation={reservation}
                  openProductModal={openProductModal}
                  onSubmitProduct={(data, cardId) => onSubmitProduct(data, cardId)}
                  setOpenProductModal={setOpenProductModal}
                />
                <Grid container spacing={1}>
                  <Grid item xs={12} md={12} lg={12} xl={8}>
                    <ShowCard iconHeader={<EventIcon />} title={translate('ra.title.reserve_information')}>
                      <CompleteSideCard>
                        <Box display={'flex'}>
                          <LeftSideCard style={{ paddingRight: 10 }}>
                            <div style={{display:'flex', flexDirection:'row', alignItems:'center', whiteSpace:'nowrap'}}>
                              <ShowElement source='status' label={translate('ra.field.status')} />
                              <HasPermission resource={'item'} permission='edit_status'>
                                <EditIcon onClick={()=>setChangeStatusDialog(true)} style={{cursor:'pointer', fontSize:'18px', color:'#6f7ce0', marginLeft:'15px'}}/>
                              </HasPermission>
                            </div>
                            <ShowElement
                              source='created_at'
                              label={translate('ra.field.created_at')}
                              dateTime
                            />
                            <ShowElement
                              source='source_relation.short_name'
                              label={translate('ra.field.source')}
                            />
                          </LeftSideCard>
                          <RigthSideCard>
                            <ShowElement
                              source={'payment_status'}
                              label={translate('ra.field.payment_status')}
                              status
                              loading={loadingFraudItem}
                              onSelectOption={(train_segment, option) => {
                                setOpenFraudModal(true)
                                setHashItemReserve(train_segment?.hash_)
                                setApproveFraud(option === 'approve')
                              }}
                            />
                            <PassengerTrainPasses reservation={reservation} />
                            <BillingStatusField />
                            {hasPermissionFunction('item', PERMISSION_IS_BILLABLE) && (
                              <Box style={{padding: '5px 0px 5px 0px'}}>
                                <Typography
                                    variant='h7'
                                    component='span'
                                    style={{
                                      padding: '0px 5px 0px 5px',
                                      fontWeight: 600,
                                      flex: 1,
                                      maxWidth: 'fit-content'
                                    }}
                                  >
                                  {translate('ra.field.is_billable')}
                                  <Checkbox checked={isBillable} onChange={onChangeBillable}/>
                                </Typography>
                              </Box>
                            )}
                            <BillingAutomaticField />
                          </RigthSideCard>
                        </Box>
                        <Typography variant='h6' component='div' color={blue} margin={'25px 5px 10px 5px'}>
                          {translate('ra.title.provider_info')}
                        </Typography>
                        <Box display={'flex'}>
                          <LeftSideCard style={{ paddingRight: 10 }}>
                            <ShowElement
                              source='supplier_relation.name'
                              label={translate('ra.field.provider')}
                            />
                            <ShowElement
                              source='pricing_relation.[0].currency_origin'
                              label={translate('ra.field.currency')}
                            />
                          </LeftSideCard>
                          <RigthSideCard>
                            <ShowElement
                              source={'booking_reference'}
                              label={translate('ra.field.provider_code')}
                            />
                            <HasPermission resource='train-detail' permission={'show_code'}>
                              <ShowElement
                                source={'x_correlation_id'}
                                styleValue={{fontSize:'11px'}}
                                label={translate('ra.field.internal_code')}
                              />
                            </HasPermission>
                          </RigthSideCard>
                        </Box>
                      </CompleteSideCard>
                    </ShowCard>
                    {/* <ConfirmationDialog
                      title={translate('ra.message.cancel_item_reserva', { reserva: nameReserve })}
                      buttonConfirmText={translate('ra.message.yes')}
                      buttonCancel={translate('ra.message.no')}
                      setOpen={setOpen}
                      setConfirm={setConfirm}
                      open={open}
                    /> */}
                    <ConfirmationDialog
                      title={translate('ra.message.cancel_train_segment_reserva', {
                        reserva: nameReserve,
                        cost: costCancel,
                        currency: currencyCostCancel,
                      })}
                      buttonConfirmText={translate('ra.message.yes')}
                      buttonCancel={translate('ra.message.no')}
                      setOpen={setOpen}
                      setConfirm={setConfirm}
                      open={open}
                      loadingMessage={costCancelLoading}
                    />
                    <Dialog fullWidth maxWidth={'lg'} open={historyCostsDialog} onClose={() => setHistoryCostsDialog(false)}>
                      <DialogTitle style={{display:'flex', flexDirection:'row', width:'100%', justifyContent:'space-between'}}>{translate('ra.title.price_history')}
                        <CloseIcon style={{cursor:'pointer'}} onClick={()=>{setHistoryCostsDialog(false)}}/>
                      </DialogTitle>
                      <DialogContent>
                          <HistoryCostsDialog/>
                      </DialogContent>
                    </Dialog>
                    <ConfirmationDialog
                      title={translate('ra.message.emit_item_reserva', { reserva: nameReserve })}
                      buttonConfirmText={translate('ra.message.yes')}
                      buttonCancel={translate('ra.message.no')}
                      setOpen={setOpenEmitModal}
                      setConfirm={setConfirmEmit}
                      open={openEmitModal}
                    />
                    <ConfirmationDialog
                      title={translate('ra.message.refresh_retrive_item_reserva', { reserva: nameReserve })}
                      buttonConfirmText={translate('ra.message.yes')}
                      buttonCancel={translate('ra.message.no')}
                      setOpen={setOpenRetriveModal}
                      setConfirm={setConfirmRetrive}
                      open={openRetriveModal}
                    />
                    <ConfirmationDialog
                      title={translate('ra.message.register_return', { reserva: nameReserve })}
                      buttonConfirmText={translate('ra.message.yes')}
                      buttonCancel={translate('ra.message.no')}
                      setOpen={setOpenRegisterReturnModal}
                      setConfirm={setConfirmRegisterReturn}
                      open={openRegisterReturnModal}
                      loadingModalButton={loadingRegisterReturnItem}
                    />
                    <ChangeStatusDialog
                      open={changeStatusDialog}
                      setOpen={setChangeStatusDialog}
                      refresh={refresh}
                    />

                    <ConfirmationDialog
                      title={translate('ra.message.delete_item_reserva', { item: nameReserve })}
                      buttonConfirmText={translate('ra.message.yes')}
                      buttonCancel={translate('ra.message.no')}
                      setOpen={setOpenDeleteModal}
                      setConfirm={setConfirmDelete}
                      open={openDeleteModal}
                      loadingModalButton={loadingDeleteItem}
                    />
                    <ConfirmationDialog
                      title={approveFraud ? translate('ra.message.approve_fraud') : translate('ra.message.refuse_fraud')}
                      buttonConfirmText={translate('ra.message.yes')}
                      buttonCancel={translate('ra.message.no')}
                      setOpen={setOpenFraudModal}
                      setConfirm={setConfirmFraud}
                      open={openFraudModal}
                    />

                    <ConfirmationDialog
                      title={translate('ra.message.clone_reservation', { reserva: nameReserve })}
                      buttonConfirmText={translate('ra.message.yes')}
                      buttonCancel={translate('ra.message.no')}
                      setOpen={setOpenCloneModal}
                      setConfirm={setConfirmClone}
                      open={openCloneModal}
                      loadingModalButton={loadingCloneItem}
                    />

                    <ConfirmationDialog
                      title={translate('ra.message.after_sales', { reserva: nameReserve })}
                      buttonConfirmText={translate('ra.message.yes')}
                      buttonCancel={translate('ra.message.no')}
                      setOpen={setOpenAfterSalesModal}
                      setConfirm={setConfirmAfterSales}
                      open={openAfterSalesModal}
                      loadingModalButton={loadingAfterSalesItem}
                    />

                    <Dialog open={openMoveModal} onClose={() => setOpenMoveModal(false)}>
                      <DialogTitle>Mover item</DialogTitle>
                      <DialogContent>
                        <Grid container spacing={3}>
                          <EditInputsWrap
                            label={translate('ra.field.reservation_number')}
                            md={12}
                            lg={12}
                            style={{ minHeight: 0 }}
                          >
                            <TextField
                              value={reservationNumberMove}
                              onChange={(e) => setReservationNumberMove(e.target.value)}
                              size='small'
                              fullWidth
                            />
                          </EditInputsWrap>
                        </Grid>
                      </DialogContent>
                      <DialogActions>
                        <Button
                          variant='outlined'
                          onClick={() => {
                            setNameReserve('')
                            setHashItemReserve('')
                            setReservationNumberMove('')
                            setOpenMoveModal(false)
                          }}
                        >
                          Cancelar
                        </Button>
                        <Button variant='contained' onClick={handleMoveItem}>
                          Aceptar
                        </Button>
                      </DialogActions>
                    </Dialog>
                  </Grid>
                  <Grid item xs={12} md={12} lg={12} xl={4}>
                    <WrapperCardId>
                      <ContactModal
                        open={openContactModal}
                        loadingButton={loadingContactModal}
                        handleClose={() => setOpenContactModal(false)}
                        onSubmit={(record, cardId) => {
                          handleUpdateContact(
                            record,
                            cardId,
                            setLoadingContactModal,
                            setOpenContactModal,
                            notify,
                            refresh,
                            setCardLoading
                          )
                        }}
                        titleModal={translate('ra.title.update_contact')}
                      />
                      <ShowCard
                        iconHeader={<PhoneIcon />}
                        title={translate('ra.title.contanct')}
                        actionButtonIcon={!editMode && <EditIcon />}
                        variant='text'
                        onClickButton={() => {
                          setOpenContactModal(true)
                        }}
                      >
                        <CompleteSideCard>
                          <ShowElement source='contact.name' label={translate('ra.field.name')} />
                          <ShowElement source='contact.surname' label={translate('ra.field.surname')} />
                          <ShowElement source='contact.email' label={translate('ra.field.email')} />
                          <ShowElement
                            source='contact.phone_number'
                            label={translate('ra.field.phone_number')}
                          />
                        </CompleteSideCard>
                      </ShowCard>
                    </WrapperCardId>

                    <WrapperCardId>
                      <ObservationsCard />
                    </WrapperCardId>
                  </Grid>
                </Grid>
                <Grid container spacing={1}>
                  <Grid item xs={12}>
                    <ShowCard iconHeader={<TrainIcon />} title={translate('ra.title.train_information')}>
                      <CompleteSideCard style={{ display: 'block' }}>
                        <Box display={'flex'}>
                          <LeftSideCard>
                            <ShowElement
                              source='passes[0].expiration_datetime'
                              styleValue={{
                                fontWeight: 600,
                                backgroundColor: 'red',
                                borderRadius: '10px',
                                padding: '0 5px 0 5px',
                              }}
                              dateFormatCustom={getDay}
                              label={translate('ra.field.expiration')}
                              icon={<CalendarMonthIcon style={{ paddingTop: '5px' }} />}
                            />
                            <ShowElement
                              source='passes[0].arrival_name'
                              styleValue={{ fontWeight: 600, color: turquoise }}
                              label={translate('ra.field.destination')}
                              icon={<LocationOnIcon style={{ color: turquoise, paddingTop: '5px' }} />}
                            />
                            <ShowElement
                              source='passes[0].products[0].label'
                              label={translate('ra.field.product')}
                            />
                            <DateInDateOutField nameNode={'passes'} />
                            <ShowElement
                              source='passes[0].period_type.description'
                              label={translate('ra.field.period_type')}
                            />
                            <ShowElement
                              source='passes[0].duration.description'
                              label={translate('ra.field.duration')}
                            />
                            <ShowElement
                              source='passes[0].rate_type'
                              label={translate('ra.field.rate_type')}
                            />
                            <ShowElement
                              source='passes[0].products[0].marketingCarrier'
                              label={translate('ra.field.marketingCarrier')}
                            />
                            <ShowElement
                              source='passes[0].products[0].supplier'
                              label={translate('ra.field.supplier')}
                            />
                          </LeftSideCard>
                          <RigthSideCard>
                            <TrainPassesExtraPassenger />
                          </RigthSideCard>
                        </Box>
                        ​
                        <TrainPassesTicket
                          source_ticket_url={'passes[0].url_ticket'}
                          source_status={'status'}
                        />
                        <TrainPassesCondition
                          open={openModalCondition}
                          handleClose={() => setOpenModalCondition(false)}
                        />
                        <Button
                          onClick={() => setOpenModalCondition(true)}
                          style={{ fontWeight: 600, textDecoration: 'underline' }}
                        >
                          {translate('ra.action.see_conditions')}
                        </Button>
                        <ContextTrainPasses />
                      </CompleteSideCard>
                    </ShowCard>
                  </Grid>
                </Grid>
              </WrapperCardId>
              <WrapperCardId>
                <Grid container spacing={1}>
                  <Grid item xs={12}>
                    <NotificationEmails />
                  </Grid>
                </Grid>
              </WrapperCardId>
              <HasPermission resource='file-upload' permission={PERMISSION_GET}>
                <WrapperCardId>
                  <Grid container spacing={1}>
                    <Grid item xs={12}>
                      <FilesCard />
                    </Grid>
                  </Grid>
                </WrapperCardId>
              </HasPermission>
              <HasPermission permission={PERMISSION_SHOW} resource={'comments'}>
                <WrapperCardId>
                  <Grid container spacing={1}>
                      <Grid item xs={12}>
                          <CommentsCardComponent itemId={train_passes[0]?.item_id}/>
                      </Grid>
                    </Grid>
                </WrapperCardId>
              </HasPermission>
            </div>
            <div className='responsive-products-pricing'>
              <Box
                style={{
                  position: 'sticky',
                  top: '10px',
                  zIndex: '1000',
                  '&.MuiPaper-root': {
                    overflow: 'visible !important',
                  },
                }}
              >
                <WrapperCardId>
                  <PricingModal
                    open={openPricingModal}
                    loadingButton={loadingPricingModal}
                    handleClose={() => setOpenPricingModal(false)}
                    onSubmit={(record, cardId) => {
                      handleUpdatePricing(
                        record,
                        cardId,
                        setLoadingPricingModal,
                        setOpenPricingModal,
                        notify,
                        refresh,
                        setCardLoading,
                        reservation
                      )
                    }}
                    titleModal={translate('ra.title.update_pricing')}
                  />
                  {!editMode && (
                    <div style={{display:'flex', flexDirection:'row', justifyContent:'flex-end'}}>
                      <Box display={'flex'} justifyContent={'flex-end'} alignItems={'center'}>
                        <HasPermission permission='hasEdit' resource={'pricing'}>
                            <Button
                            onClick={()=>{setHistoryCostsDialog(true)}}
                            sx={{ paddingX: '10px', marginX:'5px' }}
                            size='small'
                            variant='contained'
                            >
                            {translate('ra.title.price_history')}
                            </Button>
                        </HasPermission>
                      </Box>
                      <EditOriginValues setEnableReliquidation={setEnableReliquidation} isBillable={isBillable} setOpenPricingModal={setOpenPricingModal}/>
                    </div>
                  )}

                  {/* <LiquidationModal
                    open={openLiqudiationPricingModal}
                    loadingButton={loadingLiqudiationPricingModal}
                    handleClose={() => {
                      setOpenLiqudiationPricingModal(false)
                      setExchangeMode(false)
                    }}
                    exchange_mode={exchangeMode}
                    onSubmit={(body, cardId) => {
                      handleUpdateLiquidation(
                        individualRecord,
                        body,
                        cardId,
                        setLoadingLiqudiationPricingModal,
                        setOpenLiqudiationPricingModal,
                        notify,
                        refresh,
                        setCardLoading
                      )
                      setExchangeMode(false)
                    }}
                    titleModal={translate('ra.title.update_liquidation')}
                  /> */}
                  <LiquidationCards enableReliquidation={enableReliquidation} />
                </WrapperCardId>
              </Box>
            </div>
          </Box>
        </TabProduct>
      </>
    )
  }
}
